import { render, staticRenderFns } from "./FiltersTablet.vue?vue&type=template&id=b946066a&"
import script from "./FiltersTablet.vue?vue&type=script&lang=js&"
export * from "./FiltersTablet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports